/**
 * Mapeamento das 10 principais culturas para seus PDFs de fenologia/fisiologia.
 * Ao clicar em um badge de cultura, abre o PDF se existir; senão, faz busca no Google.
 */

const S3_BASE =
  "https://sudeste-online.s3.us-east-1.amazonaws.com/agroreceita/documentos";

const CULTURAS_PDF = {
  soja:     `${S3_BASE}/01_soja_estadios_fenologicos_embrapa.pdf`,
  milho:    `${S3_BASE}/02_milho_crescimento_pioneer.pdf`,
  cana:     `${S3_BASE}/03_cana_fisiologia.pdf`,
  feijao:   `${S3_BASE}/04_feijao_fenologia_embrapa.pdf`,
  arroz:    `${S3_BASE}/05_arroz_embrapa.pdf`,
  trigo:    `${S3_BASE}/06_trigo_manejo_alta_produtividade_embrapa.pdf`,
  cafe:     `${S3_BASE}/07_cafe_fenologia_embrapa.pdf`,
  mandioca: `${S3_BASE}/08_mandioca_fisiologia_embrapa.pdf`,
  girassol: `${S3_BASE}/09_girassol_embrapa.pdf`,
};

/**
 * Normaliza string: remove acentos, minúsculas, trim.
 */
function normalizar(str) {
  return (str || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

/**
 * Retorna a URL do PDF se a cultura tiver dossiê, ou busca no Google como fallback.
 * @param {string} nomeComum
 * @param {string} [nomeCientifico]
 * @returns {string} URL para abrir
 */
export function getCulturaUrl(nomeComum, nomeCientifico) {
  const n = normalizar(nomeComum);
  for (const [key, url] of Object.entries(CULTURAS_PDF)) {
    // match exato ou prefixo (ex: "cana-de-acucar".startsWith("cana"))
    if (n === key || n.startsWith(key)) {
      return url;
    }
  }
  // fallback: busca no Google
  const query = encodeURIComponent(nomeComum || nomeCientifico || "");
  return `https://www.google.com/search?q=${query}&tbm=isch`;
}

/**
 * Abre a URL da cultura em nova aba.
 * @param {string} nomeComum
 * @param {string} [nomeCientifico]
 */
export function openCulturaUrl(nomeComum, nomeCientifico) {
  const url = getCulturaUrl(nomeComum, nomeCientifico);
  window.open(url, "_blank", "noopener,noreferrer");
}
